import request from '@/router/axios'

export function getPage(query) {
    return request({
        url: '/chain/garbagecustomerwaybill/page',
        method: 'get',
        params: query
    })
}


